import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { useMemo, useRef } from 'react';
import useFocusNew from '../common/effects/useFocusNew';
import { isDark } from '../common/utils';
import styles from './link.module.scss';
const Link = ({ children, href, icon, target, accent = 'default', focusable = true, onClick, size = 'sm', highlight = false, }) => {
    const ref = useRef(null);
    let focusProps = null;
    useFocusNew(focusable ? ref : null);
    if (focusable) {
        focusProps = {
            tabIndex: 0,
        };
    }
    const isDarkMode = useMemo(() => isDark(), []);
    const linkClass = useMemo(() => {
        return classNames(styles.link, {
            [styles.btn]: accent === 'button',
            [styles[size]]: true,
            [styles.highlight]: highlight,
            [styles.dark]: isDarkMode,
        });
    }, [highlight]);
    return (_jsxs("a", { className: linkClass, target: target, href: href, ...focusProps, ref: ref, onClick: onClick, onKeyUp: e => {
            if (e.key === 'Enter') {
                onClick?.(e);
            }
        }, children: [icon && _jsx("span", { className: styles.icon, children: icon }), _jsx("span", { className: styles.text, children: children })] }));
};
Link.displayName = 'Link';
export { Link };
